import React, { FC, useEffect, useRef } from 'react';
import MyImg from '../../img/me.png';
import BarbieImg from '../../img/barbie512.png';
import CartmanImg from '../../img/cartman512.png';
import RickImg from '../../img/rick512.png';
import YodaImg from '../../img/yoda192.png';
import BatmanImg from '../../img/batman.png';
import ReactMarkdown from 'react-markdown';
import { ResponseInterface } from './response-interface';
import hljs from 'highlight.js';
import './PromptResponseList.css';
import ReactLoading from 'react-loading';

interface PromptResponseListProps {
  responseList: ResponseInterface[];
}

const PromptResponseList: FC<PromptResponseListProps> = ({ responseList }) => {
  const responseListRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    hljs.highlightAll();
  });

  useEffect(() => {
    hljs.highlightAll();
  }, [responseList]);

  const getCharacterClassname = (character: string) => {
    switch (character) {
      case 'self':
        return 'my-question';
      case 'alice':
        return 'chatgpt-response';
      default:
        return 'chatgpt-response';
    }
  };

  const getCharacterImage = (character: string) => {
    switch (character) {
      case 'self':
        return MyImg;
      case 'barbie':
        return BarbieImg;
      case 'cartman':
        return CartmanImg;
      case 'rick':
        return RickImg;
      case 'yoda':
        return YodaImg;
      case 'batman':
        return BatmanImg;
    }
  };

  return (
    <div className='prompt-response-list' ref={responseListRef}>
      {responseList.map((responseData) => (
        <div
          className={
            'response-container ' +
            getCharacterClassname(responseData.character)
          }
          key={responseData.id}>
          {responseData.character !== 'self' && (
            <img
              className='avatar-image'
              src={getCharacterImage(responseData.character)}
              alt='avatar'
            />
          )}
          <div
            className={
              (responseData.error ? 'error-response ' : '') + 'prompt-content'
            }
            id={responseData.id}>
            {responseData.image && (
              <img
                src={responseData.image}
                className='ai-image'
                alt='generated ai'
              />
            )}
            {responseData.response ? (
              <ReactMarkdown
                children={responseData.response ?? ''}
                components={{
                  code({ className, children }) {
                    return <code className={className}>{children}</code>;
                  },
                }}
              />
            ) : (
              <ReactLoading type={'bubbles'} color='white' />
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default PromptResponseList;
